import { fluid } from '@helpers/fluid';
import { baseGrid } from '@helpers/grid';
import { Device, from } from '@helpers/media';
import { paragraphSmall } from '@helpers/typography';
import styled from 'styled-components';
import SectionWrapper from '../Global/SectionWrapper/SectionWrapper';
import SectionWrapperStyles from '../Global/SectionWrapper/SectionWrapper.styles';
const Container = styled(SectionWrapper) `
  ${SectionWrapperStyles.SiteWide} {
    ${baseGrid};
  }
`;
const Inner = styled.figure `
  grid-column: 1 / -1;

  ${Container}[data-size='default'] & {
    grid-column: 1 / -1;

    @media ${from(Device.Tablet)} {
      grid-column: 2 / -2;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: 3 / -3;
    }
  }

  ${Container}[data-size='medium'] & {
    @media ${from(Device.MobileLarge)} {
      grid-column: 2 / -2;
    }

    @media ${from(Device.Tablet)} {
      grid-column: 3 / -3;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: 4 / -4;
    }
  }

  ${Container}[data-size='small'] & {
    grid-column: 2 / -2;

    @media ${from(Device.MobileLarge)} {
      grid-column: 3 / -3;
    }

    @media ${from(Device.Tablet)} {
      grid-column: 4 / -4;
    }

    @media ${from(Device.TabletLarge)} {
      grid-column: 5 / -5;
    }
  }
`;
const MediaHolder = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: var(--widgetThemeColorLight);
  text-align: center;
  aspect-ratio: 864 / 485;
`;
const Image = styled.img `
  width: 100%;
  max-height: 100%;
  object-fit: contain;
`;
const ImageCaption = styled.figcaption `
  ${paragraphSmall}
  margin-top: ${fluid(16, 24)};

  > strong {
    &::after {
      content: ' ';
    }
  }
`;
export const ImageWithCaptionStyles = {
    Container,
    Image,
    ImageCaption,
    Inner,
    MediaHolder,
};
